export const convertEnumToDropdownArray = (enumObj, addBlank = false) => {
  let output = Object.keys(enumObj).map((item, index) => {
    return {
      key: index + 1,
      value: enumObj[item],
      text: item.replace(new RegExp('_', 'g'), ' '),
    };
  });

  if (addBlank) {
    output.splice(0, 0, { key: 0, value: -1, text: '' });
  }

  return output;
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ConvertEnumToDropdownArray.js